import PropTypes from "prop-types";
import React from "react";

export const MultiValue = ({ data, getValue, selectProps }) => {
  if (selectProps.isSearchable && selectProps.menuIsOpen) {
    return null;
  }

  const selectedValues = getValue();
  if (data.value === selectedValues[0].value) {
    return <span>{data.label}</span>;
  }

  if (data.value === selectedValues[1].value) {
    return <span>, ...</span>;
  }

  return null;
};

MultiValue.propTypes = {
  data: PropTypes.object.isRequired,
  getValue: PropTypes.func.isRequired,
  selectProps: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/MultiSelect/MultiValue.js